import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { push } from 'react-router-redux';

// Service & Actions & Constants
import { clearReportStore, updateReportFilter } from './reducer/index';
import { changeTab } from 'src/views/practitioner/Appointment/reducers/actions';
import { generateStatusList, prepareDataForFilter, generatePDF, savePdf } from './services';
import {
  loadAndSaveCampusesList,
  loadAndSavePractitionersList,
  setBackUrl
} from '../reducer/commonActions';

// Components
import EmptyReporting from './components/EmptyReporting';
import InternalHeader from '../components/InternalHeader/InternalHeader';
import PaymentTable from './components/PaymentTable/PaymentTable';
import ReportFilters from './components/ReportFilters/ReportFilters';
import TotalInfoBlock from './components/TotalInfoBlock/TotalInfoBlock';
import CreateReportModal from './components/CreateReportModal/CreateReportModal';

// Styles
import RepStyles from './styles';

class Reporting extends Component {
  constructor() {
    super();
    this.state = {
      isLoadAllData: false,
      isOpenModal: false,
      generateReportStatus: generateStatusList[1],
      initFilterData: null,
      pdfBlob: null
    };
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onClickSavePDF = this.onClickSavePDF.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onOpenModal = this.onOpenModal.bind(this);
    this.initFilters = this.initFilters.bind(this);
    this.onTryGeneratePDF = this.onTryGeneratePDF.bind(this);
    this.onTableRowClick = this.onTableRowClick.bind(this);
  }

  componentDidMount() {
    const {
      common: { campusesList, practitionersList },
      loadAndSaveCampusesList,
      loadAndSavePractitionersList
    } = this.props;
    if (!practitionersList || !campusesList) {
      loadAndSaveCampusesList();
      loadAndSavePractitionersList();
    } else {
      this.initFilters();
    }
  }

  componentDidUpdate() {
    const {
      common: {
        campusesList,
        practitionersList,
        commonFilters: { practitionerId }
      }
    } = this.props;
    const { isLoadAllData, initFilterData } = this.state;

    if (!initFilterData && !isLoadAllData && practitionersList && campusesList && practitionerId) {
      this.setState({ isLoadAllData: true }, () => {
        this.initFilters();
      });
    }
  }

  componentWillUnmount() {
    const { clearReportStore } = this.props;
    clearReportStore();
  }

  onTableRowClick(rowItem) {
    const { push, changeTab, setBackUrl } = this.props;
    const { appointmentId } = rowItem;
    if (changeTab && push) {
      setBackUrl();
      changeTab('invoice');
      push(`/practitioner/appointments/${appointmentId}/appointment`);
    }
  }

  initFilters() {
    const {
      common: {
        campusesList,
        practitionersList,
        commonFilters: { campusId, practitionerId }
      },
      initStartDate
    } = this.props;

    this.setState({
      initFilterData: prepareDataForFilter({
        practitionersList,
        campusesList,
        defaultCampusId: campusId,
        defaultPractitionerId: practitionerId,
        defaultDate: initStartDate
      })
    });
  }

  onFilterChange(filterData) {
    const { updateReportFilter } = this.props;
    updateReportFilter(filterData);
  }

  onCloseModal() {
    this.setState({ isOpenModal: false, generateReportStatus: generateStatusList[1] });
  }

  onOpenModal() {
    this.setState({ isOpenModal: true, generateReportStatus: generateStatusList[1] }, () => {
      this.onTryGeneratePDF();
    });
  }

  onClickSavePDF() {
    const { filters } = this.props;
    const { pdfBlob } = this.state;
    savePdf(pdfBlob, filters);
  }

  onTryGeneratePDF() {
    const {
      reporting: { reportFilter }
    } = this.props;

    if (reportFilter) {
      generatePDF(reportFilter)
        .then(pdfBlob => {
          this.setState({
            generateReportStatus: generateStatusList[2],
            pdfBlob: {
              generateDate: new Date(),
              blob: pdfBlob
            }
          });
        })
        .catch(() => {
          this.setState({
            generateReportStatus: generateStatusList[0],
            pdfBlob: null
          });
        });
    }
  }

  render() {
    const {
      i18n,
      reporting: { reportPaidList, reportUnpaidList }
    } = this.props;
    const { isOpenModal, generateReportStatus, initFilterData } = this.state;
    const paidArr = Array.isArray(reportPaidList) ? reportPaidList : [];
    const unpaidArr = Array.isArray(reportUnpaidList) ? reportUnpaidList : [];

    return (
      <div>
        <InternalHeader />
        <RepStyles.Rep_GeneralWrapper>
          <RepStyles.Rep_PageTitle>{i18n.t('reporting_page_label')}</RepStyles.Rep_PageTitle>

          <ReportFilters data={initFilterData} onChange={this.onFilterChange} />

          {paidArr.length + unpaidArr.length ? (
            <RepStyles.Rep_ContentWrapper>
              <div className={unpaidArr.length && paidArr.length === 0 ? 'only-unpaid' : ''}>
                {paidArr.map(table => {
                  const { items } = table;
                  const uniqPostfix =
                    (Array.isArray(items) && items.length && items[0]['appointmentId'])
                    || Math.random();
                  return (
                    <PaymentTable
                      key={table.paymentMethod + uniqPostfix}
                      table={table}
                      onTableRowClick={this.onTableRowClick}
                    />
                  );
                })
                }

                {unpaidArr.length ? (
                  <PaymentTable
                    key={'unpaid-table'}
                    table={{ items: unpaidArr }}
                    onTableRowClick={this.onTableRowClick}
                    tableCaptionKey='report_unpaid'
                  />
                ) : null}
              </div>

              {paidArr.length ? (
                <div>
                  <TotalInfoBlock data={paidArr} onReportBtnClick={this.onOpenModal} />
                </div>)
                : null
              }
            </RepStyles.Rep_ContentWrapper>
          ) : (
            <EmptyReporting />
          )}
        </RepStyles.Rep_GeneralWrapper>

        {/* ──── Modal ──────────────────────────────────────────────────────────────────────── */}

        <CreateReportModal
          isOpen={isOpenModal}
          closeModal={this.onCloseModal}
          status={generateReportStatus}
          onClickSavePDF={this.onClickSavePDF}
          onTryGeneratePDF={this.onTryGeneratePDF}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  common: state.practitioner.common,
  initStartDate: state.practitioner.appointments.startDate,
  reporting: state.practitioner.reporting
});

export default translate()(
  connect(
    mapStateToProps,
    {
      changeTab,
      clearReportStore,
      loadAndSaveCampusesList,
      loadAndSavePractitionersList,
      push,
      setBackUrl,
      updateReportFilter
    }
  )(Reporting)
);
